<template>
  <div>
    <iframe id="iframeReport" name="iframeReport" style="height: 0; width: 0"></iframe>
    <section ref="invoice" style="display: none" id="printableArea">
      <v-card class="py-1 px-3 card">
        <v-banner style="padding-left: 10px" class="subtitle" single-line> Audit Report </v-banner>
        <v-row>
          <v-col>FranchiseeName: {{this.printData.FranchiseeName[0].companyName}}</v-col>
          <v-col>Center:
            {{this.printData.FranchiseeName[0].companyName}}
          </v-col>
          <v-col>Audited By:
            {{this.printData.auditedByName[0].firstName+" "+this.printData.auditedByName[0].lastName}}
          </v-col>
          <v-col>Date: {{ printData.auditDate }}</v-col>
        </v-row>
        <v-row>
            <v-col>Overall Rating: {{ this.printData.overallScore ? Math.round(parseFloat(this.printData.overallScore)) : '0'}}</v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-banner style="padding-left: 10px" class="subtitle" single-line>Contents: </v-banner>
        </v-row>
        <v-row>
          <v-col v-for="(item, i) in printData.auditCategoryMaps" :key="i" cols="12" sm="12" md="6">
            <h2 style="font-size:18px; font-weight: 500">{{item.category.categoryName}}</h2>
            <v-row style="padding-top: 20px">
              <v-col v-for="(cData, i) in item.subCategories" :key="i" cols="12" sm="12">
                <h3 style="font-size:16px; font-weight: 500">{{cData.subcategoryName}}</h3>
                <v-row>
                  <v-col v-for="(parameterData, i) in cData.parameters" :key="i" cols="12" sm="12">
                    <h4 style="font-size:15px; font-weight: 500">Parameter Name: {{parameterData.parameterName}}
                    </h4>
                    <br/>
                    <h4 style="font-size:15px; font-weight: 500">Parameter Response: {{parameterData.response.responseType}}
                    </h4>
                    <br/>
                    <h4 style="font-size:15px; font-weight: 500" v-if="parameterData.remark">Parameter Remark: {{parameterData.remark}}
                    </h4>
                  </v-col>

                </v-row>
              </v-col>
            </v-row>

          </v-col>
        </v-row>
      </v-card>
    </section>
  </div>
</template>

<script>
export default {
  name: 'OnlineClassList',
  props: ['printData'],
  components: {},
  data () {
    return {
      prtHtml: ''
    }
  },

  computed: {},
  watch: {},
  created () {
    console.log(this.printData, 'Audit Report')
  },
  mounted () {
    // this.printInvoice()
  },
  methods: {}
}
</script>
<style scoped>
@media print {
  #printableArea,
  #printableArea * {
    visibility: visible;
  }
  #printableArea {
    position: absolute;
    left: 0;
    top: 0;
  }
  #printableArea1,
  #printableArea1 * {
    visibility: visible;
  }
  #printableArea1 {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
